import { useContext } from 'react'
//Context
import { appContext } from "../../AppContext";

export function useDiscord() {
    const [appState] = useContext(appContext);

    function sendDiscordUpdate(message, isAdminOverride) {
        let url = "";
        const configs = appState.configurations;
        if(configs.length <= 0 
            || configs.find(_ => _.name === "IsProduction")?.configValue !== "true") {
            return;
        }

        switch (appState.storyName) {
            case "Agnoia":
                url = configs.find(_ => _.name === "Discord.Agnoia")?.configValue
                break;
            case "Stormvloed":
                url = configs.find(_ => _.name === "Discord.Stormvloed")?.configValue
                break;
            default:
                return;
        }

        if(isAdminOverride) {
            url= configs.find(_ => _.name === "Discord.Admin")?.configValue
        }

        const body = {
            content : message
        }

        const headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
        });

        fetch( url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
    }

    return [sendDiscordUpdate]
}